import React from 'react';
import { Block } from '@mui/icons-material';
import Weirdtext1 from "../img/weirdtext/Weirdtext1.png"
import Weirdtext2 from "../img/weirdtext/Weirdtext2.png"

const WeirdWritings = ({ onImageClick }) => {
  return (
    <>
      <div className="help-center__examples help-center__examples--first">
        <div className="help-center__examples-header">
          <Block />
          <h3 className="help-center__examples-title">Weird text and writing issues to avoid</h3>
        </div>
        
        <div className="help-center__example-card">
          <div className="help-center__example-images help-center__example-images--grid-2">
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box">
                <img src={Weirdtext1} alt="" onClick={() => onImageClick && onImageClick(Weirdtext1)} style={{cursor: 'pointer'}} />
              </div>
              <div className="help-center__image-caption">
              Text does not make any sense
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box">
              <img src={Weirdtext2} alt="" onClick={() => onImageClick && onImageClick(Weirdtext2)} style={{cursor: 'pointer'}} />
              </div>
              <div className="help-center__image-caption">
               Random copyrights
              </div>
            </div>
            
          </div>
          
        

        </div>
      </div>
    </>
  );
};

export default WeirdWritings;